import React,{Component} from 'react';
import CompanyInfo from './CompanyInfo';

class About extends Component {
    render() {
        return (
            <div>
                <CompanyInfo/>
            </div>
        )
    }
}

export default About;